module.exports = __webpack_public_path__ + "img/EAJ_GT_LAVAGNA.7368cba9.jpg";